import promiseClient from 'hub-http/adapters/promiseClient';
import { environmentUrl, hubletApi } from 'hub-http/middlewares/core';
import { createHubSpotterStack } from 'hubspotter-http/stacks/hubSpotter';
const toolsApi = environmentUrl(hubletApi('tools', 'hubteam'));
export default promiseClient(createHubSpotterStack(toolsApi));